export default {
    methods: {
        downloadTextFile(content: any, filename: any) {
            const blob = new Blob([content], {type: "application/txt"});
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = '_Error' + filename + '.txt';
            link.click();
        }
    }
}